import React from 'react';

const TONES = {
  default: 'ds-chip--default',
  success: 'ds-chip--success',
  warning: 'ds-chip--warning',
  error: 'ds-chip--error',
  info: 'ds-chip--info',
  primary: 'ds-chip--info',
  secondary: 'ds-chip--default',
};

export function Chip({
  label,
  tone = 'default',
  className = '',
  icon,
  selected = false,
  onClick,
  disabled = false,
}) {
  const toneClass = TONES[tone] || TONES.default;
  const isInteractive = typeof onClick === 'function';
  const classes = ['ds-chip', toneClass, selected ? 'ds-chip--selected' : '', className]
    .filter(Boolean)
    .join(' ');

  const content = (
    <>
      {icon ? (
        <span className="ds-chip__icon" aria-hidden>
          {icon}
        </span>
      ) : null}
      {label}
    </>
  );

  if (isInteractive) {
    return (
      <button
        type="button"
        className={classes}
        onClick={onClick}
        disabled={disabled}
        aria-pressed={selected}
      >
        {content}
      </button>
    );
  }

  return <span className={classes}>{content}</span>;
}

export default Chip;
